import { t } from '@/i18n/utils'

/**
 * Recommend 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  // 与 en.json 不完全匹配（大小写不同）
  get end() { return t('end') },
  // 与 en.json 不完全匹配（大小写不同）
  get ongoing() { return t('ongoing') },
  // 与 en.json 不完全匹配
  get endDescription() { return t('endDescription') },
  // 与 en.json 不完全匹配
  get ongoingDescription() { return t('ongoingDescription') },
  // 与 en.json 不完全匹配
  get failedToLoad() { return t('failedToLoad') },
  get youMightAlsoLike() { return t('Retention') },
  get more() { return t('More') },
  get loading() { return `${t('Loading')}...` },
} as const

export const recommendCommonConfig = {
  texts: commonTexts,
}
